import { Divider, Dot, Flex, Text } from '@bitrise/bitkit';
import React, { FunctionComponent } from 'react';
import OverviewTooltipComparison from '../OverviewTooltip/OverviewTooltipComparison';

type Props = {
  activeCurrentValue: number | null;
  activePreviousValue: number | null;
  newCurrentValue: number | null;
  newPreviousValue: number | null;
};

const OverviewUserCountsTooltip: FunctionComponent<Props> = ({
  activeCurrentValue,
  activePreviousValue,
  newCurrentValue,
  newPreviousValue,
}) => {
  return (
    <Flex direction="horizontal" gap="x8">
      <Flex>
        <Flex alignChildrenVertical="middle" direction="horizontal" gap="x1">
          <Flex>
            <Dot backgroundColor="darkblue-2" borderColor="gray-1" borderWidth="x2" size="12px" />
          </Flex>

          <Flex>
            <Text config="8">Active Users</Text>
          </Flex>
        </Flex>

        <OverviewTooltipComparison
          currValue={activeCurrentValue}
          prevValue={activePreviousValue}
          unit="1"
        />
      </Flex>

      <Flex paddingVertical="x4">
        <Divider color="gray-8" direction="vertical" width="1px" />
      </Flex>

      <Flex>
        <Flex alignChildrenVertical="middle" direction="horizontal" gap="x1">
          <Flex>
            <Dot backgroundColor="grape-5" borderColor="gray-1" borderWidth="x2" size="12px" />
          </Flex>

          <Flex>
            <Text config="8">New Users</Text>
          </Flex>
        </Flex>

        <OverviewTooltipComparison
          currValue={newCurrentValue}
          prevValue={newPreviousValue}
          unit="1"
        />
      </Flex>
    </Flex>
  );
};

export default OverviewUserCountsTooltip;
